import { createContext } from 'react';

const SortContext = createContext({})

export  {SortContext}